import SubHeaders from '@/components/Headers/SubHeaders'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import Summary from '@/modules/Report/components/EmployeeIncome/components/Summary'
import IncomesView from '@/modules/Report/components/EmployeeIncome/components/Incomes'
import useAuthStore from '@/stores/useAuthStore'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useMyIncomeList } from './hooks/use-my-income-list'

const ALLOWED_DEPTS = [
    'BOARD OF DIRECTORS',
    'BOARD OF MANAGEMENT',
    'SALES',
    'ACCOUNT',
]

const MyIncomes = () => {
    const { t } = useTranslation()
    const employee = useAuthStore((state) => state.employee)

    const hasAccess = ALLOWED_DEPTS.includes(
        employee?.department_name?.toUpperCase() || ''
    )

    const {
        incomes,
        pagination,
        stateComponent,
        isFetching,
        isLoading,
        stats,
        control,
        setFilter,
        searchInputProps,
        params,
        queryParams,
        columns,
        filterItems,
        EMPLOYEE_INCOME_EXCEL_COLUMNS,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t: tReport,
    } = useMyIncomeList()

    if (!hasAccess) return <ErrorPage status={403} />

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.account, title: t('account') },
                    { path: '', title: t('my-incomes') },
                ]}
            />

            <div className="space-y-2 mt-2">
                <Summary stats={stats} />
                <IncomesView
                    incomes={incomes}
                    pagination={pagination}
                    stateComponent={stateComponent}
                    isFetching={isFetching}
                    isLoading={isLoading}
                    columns={columns}
                    filterItems={filterItems}
                    control={control}
                    setFilter={setFilter}
                    searchInputProps={searchInputProps}
                    params={params}
                    queryParams={queryParams}
                    excelColumns={EMPLOYEE_INCOME_EXCEL_COLUMNS}
                    handleSortChange={handleSortChange}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                    t={tReport}
                    storageKey="my-income-list"
                />
            </div>
        </div>
    )
}

export default MyIncomes
